import axios from "axios";
import { AppDispatch } from "../../store/store";
import apiRoutes from "../../views/common/utils/apiRoutes";
import {
  fetchAuthListingSuccess,
  fetchListings,
  fetchListingsFailure,
  fetchListingsMore,
  fetchListingsMoreSuccess,
  fetchListingsSuccess,
} from "../../store/slices/buyer/listingsSlice";
import {
  fetchListing,
  fetchListingFailure,
  fetchListingSuccess,
} from "../../store/slices/buyer/listingSlice";
import { CustomAxios } from "../customAxios";
import {
  IAPIResponse,
  IFilterFetch,
  IListing,
} from "../../views/common/utils/interfaces";
import { BACKEND_URL } from "../../views/common/utils/constants";
import { errorToastify } from "../../views/common/utils/Toasty";
import { getQueryStrings } from "../../views/common/utils/helpers";

export const getListings =
  (queryString = "", isLoadMore = false) =>
  async (dispatch: AppDispatch, getState: () => any) => {
    try {
      const access_token = localStorage.getItem("access_token");

      if (isLoadMore) {
        dispatch(fetchListingsMore());
      } else {
        dispatch(fetchListings());
      }

      let url;
      let response;

      if (isLoadMore) {
        const { pagination } = getState().listings;
        if (!pagination.next) {
          dispatch(fetchListingsFailure("No more pages to load"));
          return;
        }
        url = pagination.next;
      } else {
        if (access_token !== null) {
          url = `${apiRoutes.buyerListing.loggedIn}${queryString}`;
        } else {
          url = `${apiRoutes.buyerListing.view}${queryString}`;
        }
      }

      if (
        access_token !== null &&
        !isLoadMore &&
        url.includes(apiRoutes.buyerListing.loggedIn)
      ) {
        response = await CustomAxios().get(url);
      } else {
        response = await axios.get(url);
      }

      // Dispatch success action
      if (isLoadMore) {
        dispatch(fetchListingsMoreSuccess(response.data));
      } else {
        dispatch(fetchListingsSuccess(response.data));
      }
    } catch (error: any) {
      console.error("Error fetching listings:", error);
      dispatch(
        fetchListingsFailure(
          error.response?.data?.message ||
            error.message ||
            "Could not fetch listings"
        )
      );
    }
  };

export const getdListings =
  (queryString = "") =>
  async (dispatch: AppDispatch) => {
    try {
      let response;
      const access_token = localStorage.getItem("access_token");
      dispatch(fetchListings());
      if (access_token !== null) {
        response = await CustomAxios().get(
          `${apiRoutes.buyerListing.loggedIn}${queryString}`
        );
      } else {
        response = await axios.get(
          `${apiRoutes.buyerListing.view}${queryString}`
        );
      }
      dispatch(fetchListingsSuccess(response.data.data));
    } catch (error: any) {
      dispatch(
        fetchListingsFailure(
          error.response?.data?.message || "Could not fetch listings"
        )
      );
    }
  };

export const getListings2 = async (queryString = "") => {
  try {
    let response;
    const access_token = localStorage.getItem("access_token");
    if (access_token !== null) {
      response = await CustomAxios().get(
        `${apiRoutes.buyerListing.loggedIn}${queryString}`
      );
    } else {
      response = await axios.get(
        `${apiRoutes.buyerListing.view}${queryString}`
      );
    }
    return response.data.data;
  } catch (error: any) {
    errorToastify(error.response?.data?.message || "Could not fetch listings");
  }
};

export const getAuthListings =
  (queryString = "") =>
  async (dispatch: AppDispatch) => {
    try {
      const { data: result }: IAPIResponse = await CustomAxios().get(
        `${apiRoutes.buyerListing.loggedIn}${queryString}`
      );

      if (!result?.status) {
        throw new Error(result?.message);
      }

      dispatch(fetchAuthListingSuccess(result.data));
      return result;
    } catch (error) {
      if (typeof error === "string") {
        errorToastify(error);
      }
    }
  };

export const getAuthListing = async ({ queryKey }: { queryKey: any[] }) => {
  const { listingId, getRef } = queryKey[1] || {};

  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${apiRoutes.buyerListing.loggedIn}/${listingId}${
        getRef ? "?include_pr=null" : ""
      }`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }

    return result?.data as IListing;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const toggleSaveListing =
  (id: string) => async (dispatch: AppDispatch) => {
    try {
      const axios = CustomAxios();
      const response = await axios.post(`/listings/${id}/toggle-save`);
      dispatch(toggleSaveListing(id));
    } catch (error: any) {}
  };

export const getListing = (id: string) => async (dispatch: AppDispatch) => {
  try {
    let response;
    const access_token = localStorage.getItem("access_token");
    dispatch(fetchListing());
    if (access_token !== null) {
      response = await CustomAxios().get(
        `${apiRoutes.buyerListing.view}/${id}`
      );
    } else {
      response = await axios.get(`${apiRoutes.buyerListing.view}/${id}`);
    }
    dispatch(fetchListingSuccess(response.data.data));
  } catch (error: any) {
    dispatch(
      fetchListingFailure(
        error.response?.data?.message || "Could not fetch listing"
      )
    );
  }
};

export const getSavedListings = async (layoutSearchText?: string) => {
  try {
    const searchString = layoutSearchText ? `?search=${layoutSearchText}` : "";
    const { data: result }: IAPIResponse = await CustomAxios().get(
      // `${BACKEND_URL}/listings?saved_by_user=true`
      `${BACKEND_URL}/listings/saved${searchString}`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const postToggleSaveListing = async ({
  id,
  url,
}: {
  id?: string;
  url?: string;
}) => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().post(
      `${id ? `${BACKEND_URL}/listings/${id}` : url}/toggle-save`
    );
    // const result = tempDummy;

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getBuyerProperties = async (layoutSearchText?: string) => {
  try {
    const searchString = layoutSearchText ? `?search=${layoutSearchText}` : "";

    const { data: result }: IAPIResponse = await CustomAxios().get(
      // `${BACKEND_URL}/listings?saved_by_user=true`
      `${BACKEND_URL}/listings/buyer-properties/${searchString}`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getBuyerTransactions = async (filter?: IFilterFetch) => {
  try {
    const { searchQuery, filterQuery } = getQueryStrings(filter);

    const { data: result }: IAPIResponse = await CustomAxios().get(
      // `${BACKEND_URL}/listings?saved_by_user=true`
      `${BACKEND_URL}/payments/buyer-transactions?${searchQuery}${filterQuery}`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};
